(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-custom"] && !Shopify.designMode) return;
  try {
    
// No JavaScript required for static gallery layout at this time.

  } catch(e) { console.error(e); }
})();
})();
